import { autoinject, transient, computedFrom, useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { RightshipEntityAttachmentManager } from "../../common-steps/rightship-entity-attachment/rightship-entity-attachment-manager";
import { AttachmentClientService } from "../../../../../services/attachment/attachments-client.service";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { UserClaimsService } from "../../../../../services/authentication/user-claims.service";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { QueriesClientService } from "../../../../../services/queries/queries-client.services";
import { BindingSignaler } from "aurelia-templating-resources";
import { Claims } from "../../../../../constants/authentication/claims";
import { SafetyRatingReviewStatusEnum } from "../../../../../models/vetting/vetting.models";
import { RightShipDialogServiceConstants } from "../../../../../constants/basics/rightship-dialog.constants";
import { RightshipEntityAttachmentModel } from "../../../../../models/attachment/attachment.models";
import { RightshipConfirmationDialogModel } from "../../../../dialogs/rightship-confirmation-dialog/rightship-confirmation-dialog";

@autoinject
@transient()
@useView('views/pages/modules/safety-score-review/tabs/safety-score-review-documents.html')
export class SafetyScoreReviewDocuments extends RightshipEntityAttachmentManager {
    public multiple:boolean = true;
    public accept: string = "application/pdf,image/png,image/jpeg,image/jpg,application/zip,application/x-zip-compressed,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,application/vnd.ms-outlook,.msg";

    constructor(attachmentClientService: AttachmentClientService, notificationService: NotificationClientService, userClaimsService: UserClaimsService,
        dialogService: DialogClientService, i18N: I18N, queriesClientService: QueriesClientService,
        bindingSignaler: BindingSignaler) {
        super(attachmentClientService, notificationService, userClaimsService, dialogService, i18N, queriesClientService, bindingSignaler);
    }

    @computedFrom("rootItem", "rootItem.safetyRatingReviewStatusId")
    public get statusIsFinal(): boolean {
        return this.rootItem && ( this.rootItem["safetyRatingReviewStatusId"] == SafetyRatingReviewStatusEnum.Accepted2
        || this.rootItem["safetyRatingReviewStatusId"] == SafetyRatingReviewStatusEnum.AcceptedFromSystem
        || this.rootItem["safetyRatingReviewStatusId"] == SafetyRatingReviewStatusEnum.Canceled);
    }

    public openAttachmentsDialog() {
        this.itemInEdit = null;
        this.dialogService.show(RightShipDialogServiceConstants.URLs.RightshipAttachmentsDialog, this, true, false, false, 'right');
    }

    @computedFrom('rootItem', 'getItemId')
    public get canAdd(): boolean {
        return super.canAdd && (this.entityId && this.entityId > 0) && this.userClaimsService.hasPermission(Claims.CanAddSafetyRatingReviewDocuments);
    }

    @computedFrom('rootItem', 'getItemId')
    public get canDelete(): boolean {
        return super.canDelete && (this.entityId && this.entityId > 0) && this.userClaimsService.hasPermission(Claims.CanRemoveSafetyRatingReviewDocuments);
    }

    public remove($event, item: RightshipEntityAttachmentModel) {
        $event.stopPropagation();
        const deleteItem = item;

        const model = new RightshipConfirmationDialogModel();
        model.confirm = this.i18N.tr('delete-text');
        model.cancel = this.i18N.tr('cancel-text');
        model.messages.push(this.i18N.tr('are-you-sure-you-want-to-delete'));
        model.title = this.i18N.tr('confirm-delete-text');
        model.onConfirm = () => {
            this.removeInternal($event, deleteItem).then(() => {
                this.notificationService.show(this.i18N.tr("attachment-was-deleted-text"), "", NotificationType.Success);
                this.dialogService.hide();
            }).catch(() => {
                this.notificationService.show(this.i18N.tr("error-text") + "!", this.i18N.tr("attachment-could-not-be-deleted-text"), NotificationType.Error);
                this.dialogService.hide();
            });
        };
        this.dialogService.show(RightShipDialogServiceConstants.URLs.RightshipConfirmationDialog, model, true, false, false);

    }

    public loadAttachments() {
        return new Promise<void>((resolve, reject) => {
            if (this.isLoadingAttachments || !this.shouldLoadAttachments) {
                resolve();
                return;
            }

            this.isLoadingAttachments = true;

            this.items = [];

            this.queriesClientService.getData('odata/RightShipAttachments/Genesis.GetAttachments(entityTypeId='+this.rootEntityType+',entityId=' + (<any>this.rootItem).id + ')').then(results => {
                this.items = results.value
                if (this.onAttachmentsLoaded) {
                    this.onAttachmentsLoaded();
                }
                this.isLoadingAttachments = false;
                resolve();
            }).catch(() => {
                this.isLoadingAttachments = false;
                reject();
            });
        });
    }
}